var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_946",
    "data-name": "Groupe 946",
    transform: "translate(17109 1722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_458",
    "data-name": "Ellipse 458",
    transform: "translate(-17108 -1721)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_924",
    "data-name": "Groupe 924",
    transform: "translate(-17109.02 -1717.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_460",
    "data-name": "Ellipse 460",
    transform: "translate(10.021 0.204)",
    fill: "#f7f7f7",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    transform: "translate(0.021 0.204)",
    fill: "#f7f7f7",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_925",
    "data-name": "Groupe 925",
    transform: "translate(-17101.797 -1722.021) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_460-2",
    "data-name": "Ellipse 460",
    transform: "translate(10.021 0.204)",
    fill: "#f7f7f7",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_462-2",
    "data-name": "Ellipse 462",
    transform: "translate(0.021 0.204)",
    fill: "#f7f7f7",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/CHART.151a627bba7709b362d19b291dede989.svg";
export { ForwardRef as ReactComponent };